var map = {
	"./BookCharity.svg": "db35",
	"./account.svg": "2407",
	"./arrow.png": "c5d4",
	"./book.jpg": "1c16",
	"./books.jpg": "7ecb",
	"./cart.svg": "6f5d",
	"./cover.webp": "0434",
	"./description-image.jpg": "00b7",
	"./description-medium.png": "db7c",
	"./dog.jpg": "2fe6",
	"./doggie_for_bookcharity.gif": "3234",
	"./logo.png": "cf05",
	"./page1.jpeg": "a410",
	"./page10.jpeg": "6a18",
	"./page11.jpeg": "b650",
	"./page2.jpeg": "5e63",
	"./page3.jpeg": "2ab0",
	"./page4.jpeg": "0acf",
	"./page5.jpeg": "9bde",
	"./page6.jpeg": "d7e9",
	"./page7.jpeg": "29e0",
	"./page8.jpeg": "5802",
	"./page9.jpeg": "86ed",
	"./shop/stickers.png": "bc5c",
	"./shop/zak.jpeg": "3974",
	"./shop/zak2.png": "7bfb",
	"./stephenknig.png": "c25b",
	"./stivenknig.jpeg": "18de",
	"./upload.svg": "c118"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";